import React from "react";
import "./index.scss";

import { BrowserRouter } from "react-router-dom";
import { DefaultRootState, Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import App from "./app/App";
import configureStore from "app/configure.store";
import { decompressFromBase64 } from "lz-string";
import { createRoot } from "react-dom/client";

let initialState: DefaultRootState | undefined = undefined;
const store = configureStore(initialState);

if (window.__PRELOADED_STATE__) {
    const compressed = decompressFromBase64(window.__PRELOADED_STATE__);
    initialState = JSON.parse(compressed ?? "");
    delete window.__PRELOADED_STATE__;
}

if (typeof (document) !== "undefined" && typeof (window) !== "undefined") {
    setTimeout(() => {
        document.documentElement.style.setProperty("--scrollbar-width", (window.innerWidth - document.body.clientWidth) + "px");
    }, 250);
}

const container = document.getElementById("root");
if (container) {
    const root = createRoot(container);
    root.render(
        <HelmetProvider>
            <BrowserRouter>
                <Provider store={store}>
                    <App />
                </Provider>
            </BrowserRouter>
        </HelmetProvider>
    );
}
